import * as PapeisService from '@/modules/system/papeis/papeis.service';
import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { Link } from 'react-router-dom';
import { ReadPapelDto } from '@/api.types';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import React, { useState, useEffect } from 'react';

export default function PermissoesIndexPage() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadPapelDto[], number]>();

  const tableState = useDataTableState('nome');

  const handleBuscar = () => {
    PapeisService.readPapelListagem(
      (tableState.currentPage - 1) * tableState.pageSize,
      tableState.pageSize,
      tableState.sortConfig.direction,
      tableState.sortConfig.key
    )
      .then((result) => {
        setRegistros(result);
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  }

  useEffect(() => {
    handleBuscar();
  }, [tableState.currentPage, tableState.pageSize, tableState.sortConfig.key, tableState.sortConfig.direction]);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Papeis_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  let colunas: Column<ReadPapelDto>[] = [
    { key: "nome", header: "Papel" },
    {
      key: "usuarios", header: "Usuários Associados",
      render: (row) => {
        // Se não tiver usuários carregados, mostra 0 (será carregado sob demanda se necessário)
        return (<>{row.usuarios?.length ?? 0}</>)
      }
    },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Papeis_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Papéis do Sistema</h3>
          <span className="blockquote-footer pb-4 text-end">
            Define permissões e acessos.
          </span>
        </div>

        <hr className="pb-4" />
        {registros &&
          <DataTable
            columns={colunas}
            data={registros[0]}
            renderSubRow={(r) => {
              // Se não tiver usuários carregados, não renderiza (ou carrega sob demanda)
              if (!r.usuarios || r.usuarios.length === 0) {
                return <div className='ms-5'>Nenhum usuário associado</div>;
              }
              return (
                <div className='ms-5'>
                  {r.usuarios
                    .sort((a, b) => (a.pessoa?.nome || '').localeCompare(b.pessoa?.nome || ''))
                    .map(a => {
                      return <React.Fragment key={a.id}>
                        {a.pessoa?.nome || ''}
                        <br />
                      </React.Fragment>
                    })}
                </div>
              )
            }}
            initialSortKey='nome'
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros[1]}
          />
        }
      </div>
    </>
  );
}
